import showErrorMessage from '../new-boost/js/showErrorMessage';

/**
 * Display warnings to user if passed in via GET
 */
export default function redirectWarnings() {
    //displayWarning
    let displayWarning = jQuery("[name=displayWarning]").val();
    let $warningFocus = jQuery("[name=warningFocus]"); // the value of this field is a jQuery selector

    if (displayWarning) {

        // Focus the trouble element and scroll to it
        if ($warningFocus.val() && jQuery($warningFocus.val()).length) {
            window.setTimeout(() => {
                showErrorMessage(displayWarning);

                // Focus the element
                jQuery($warningFocus.val()).get(0).focus({
                    preventScroll: true
                });

                // Scroll to element
                jQuery($warningFocus.val()).get(0).scrollIntoView(
                    {behavior: "smooth", block: "center", inline: "nearest"}
                );
            }, 1000); // A bit of a hack but just for server errors which we should be preventing client-side anyway
        } else {
            showErrorMessage(displayWarning);
        }
    }
}